import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum PayTypeEnum {
    None = 0,
    Salary = 1,
    Hourly = 2,
    PerVisit = 3
}

export class PayTypeEnumClass extends EnumWithDescription<PayTypeEnum> {
    public readonly enum = PayTypeEnum;
    public readonly enumName: string = "PayType";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<PayTypeEnum>> = new Map([
        [
            "None",
            {
                value: PayTypeEnum.None,
                name: "None"
            }
        ],
        [
            "Salary",
            {
                value: PayTypeEnum.Salary,
                name: "Salary"
            }
        ],
        [
            "Hourly",
            {
                value: PayTypeEnum.Hourly,
                name: "Hourly"
            }
        ],
        [
            "PerVisit",
            {
                value: PayTypeEnum.PerVisit,
                name: "PerVisit"
            }
        ]
    ]);
}

export const PayType = new PayTypeEnumClass();
